import React, { useState } from "react";
import {
  List,
  SwipeableDrawer,
  IconButton,
  ListItem,
  Paper,
  Divider,
  Box
} from "@material-ui/core";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import EmergencyNumberBar from "../EmergencyNumberBar";
import menuItems from "../../data/menu_links";
import LinkEcco from "../Link";
import CloseIcon from "@material-ui/icons/Close";
import AccountCircle from "@material-ui/icons/AccountCircle";
import style from "./styles";
import { useStyles } from "../../hooks";
import { EccoColor } from "../../components/Icons";
import { Capacitor } from '@capacitor/core';
import { Facebook, LinkedIn, Instagram } from "../Icons";
import { Browser } from '@capacitor/browser';

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    padding: "0 10px"
  }
})(MuiExpansionPanelDetails);

const HeaderDrawer = () => {
  const styles = useStyles(style);
  const [managment, setManagment] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  });
  const [expanded, setExpanded] = useState("panel1");

  const toggle = (side, open) => event => {
    if (event &&
      event.type === "keydown" &&
      (event.key === "Shift" || event.key === "Tab")
    ) {
      return;
    }

    setManagment({ ...managment, [side]: open });
  };

  const handlePanelExpansion = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const openCapacitorSite = async (link) => {
    const linkUrl = link.url;
    await Browser.open({ url: linkUrl });
  }

  const sideBarMenu = side => (
    <div className={styles.list} role="presentation">
      <List>
        <Paper className={Capacitor.getPlatform() === 'ios' ? styles.paperiOS : styles.paper}>
          <Typography style={{ fontWeight: "bold", fontSize: 18, marginLeft: "-7px" }}>
            MENU
            <IconButton
              onClick={toggle("right", false)}
              className={styles.button}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
        </Paper>
        {menuItems.map(item =>
          item.static ? (
            <ExpansionPanel
              key={`ep${item.key}`}
              square
              expanded={expanded === item.key}
              onChange={handlePanelExpansion(item.key)}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id={item.key}
              >
                <Typography className={styles.title}>
                  {item.label.toUpperCase()}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <List className={styles.expansionList}>
                  {item.elemens.map(child => (
                    <div key={`div-item-${child.key}`}>
                      <ListItem
                        key={`item-${child.key}`}
                        onClick={toggle("right", false)}
                      >
                        <LinkEcco
                          to={Capacitor.getPlatform() === "android" ? null : `/${child.key}`}
                          className={styles.link}
                          external={Capacitor.getPlatform() === "android" ? false : child.external}
                          url={Capacitor.getPlatform() === "android" ? null : child.url ? child.url : null}
                          onClick={Capacitor.getPlatform() === "android" ? () => openCapacitorSite(child) : null}
                        >
                          {child.label}
                        </LinkEcco>
                      </ListItem>
                      {!child.last && <Divider className={styles.divider} />}
                    </div>
                  ))}
                </List>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ) : (
            <Paper key={`p${item.key}`} className={styles.itemPaper}>
              <Typography onClick={toggle("right", false)}>
                <LinkEcco
                  to={Capacitor.getPlatform() === "android" ? null : `/${item.key}`}
                  external={Capacitor.getPlatform() === "android" ? false : true}
                  url={Capacitor.getPlatform() === "android" ? null : item.url ? item.url : null}
                  className={styles.title2}
                  onClick={Capacitor.getPlatform() === "android" ? () => openCapacitorSite(item) : null}r
                >
                  {item.label.toUpperCase()}
                </LinkEcco>
              </Typography>
            </Paper>
          )
        )}
        <Box className={styles.crossIcon} >
          <Typography variant="h6" className={styles.textRedes}>
            ¡Seguinos!
          </Typography>
          <LinkEcco
            external={true}
            url="https://www.facebook.com/eccoemergencias"
            href="https://www.facebook.com/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <Facebook style={{ marginRight: 16, fontSize: "30px", }} />
          </LinkEcco>
          <LinkEcco
            external={true}
            url="https://www.instagram.com/eccoemergencias"
            href="https://www.instagram.com/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <Instagram style={{ marginRight: 16, fontSize: "30px", }} />
          </LinkEcco>
          <LinkEcco
            external={true}
            url="https://www.linkedin.com/company/eccoemergencias"
            href="https://www.linkedin.com/company/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <LinkedIn style={{ marginRight: 6, fontSize: "30px", }} />
          </LinkEcco>
        </Box>
      </List>
    </div>
  );

  return (

    <Box
      className={Capacitor.getPlatform() === 'ios' ? styles.rootiOS : styles.root}
    >
      <EmergencyNumberBar />
      <LinkEcco to="/" className={styles.eccoLogo}>
        <EccoColor className={styles.logo} />
      </LinkEcco>
      <Box style={{ position: "relative" }}>
        <IconButton style={{ position: "absolute", right: 50, top: 20 }}>
          <LinkEcco to={"/"} style={{ color: "#4D4F5C" }}>
            <AccountCircle />
          </LinkEcco>
        </IconButton>
        <IconButton
          onClick={toggle("right", true)}
          style={{ position: "absolute", right: 5, top: 20 }}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          open={managment.right}
          anchor="right"
          onClose={toggle("right", false)}
          onOpen={toggle("right", true)}
        >
          {sideBarMenu("right")}
        </SwipeableDrawer>
      </Box>
    </Box>
  );
};

export default HeaderDrawer;